var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowUpIcon = function SvgArrowUpIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79066 6.19787L6.50066 3.90787V11.4949C6.50066 12.0449 6.05066 12.4949 5.50066 12.4949C4.94966 12.4949 4.50066 12.0449 4.50066 11.4949V3.90787L2.20966 6.19787C1.82066 6.58687 1.18466 6.58687 0.795656 6.19787C0.406656 5.80887 0.406656 5.17287 0.795656 4.78387L4.79366 0.786873C4.85166 0.726872 4.92566 0.694874 4.99366 0.653873C5.03566 0.628874 5.06966 0.592874 5.11566 0.572873C5.15666 0.554873 5.20266 0.554873 5.24566 0.544873C5.45766 0.487873 5.68166 0.488873 5.88566 0.572873C5.92966 0.591873 5.96266 0.626873 6.00366 0.651873C6.07366 0.692873 6.14666 0.725873 6.20766 0.786873L10.2047 4.78387C10.5937 5.17287 10.5937 5.80887 10.2047 6.19787C9.81566 6.58787 9.17966 6.58787 8.79066 6.19787Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowUpIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-up-icon.7e5a12da.svg";
export { ForwardRef as ReactComponent };